<template>
    <div class="container container_products product_details">

        <div v-if="!DBitems || loading" class="d-flex flex-row justify-content-center loading_card">
            <!-- LOADER -->
            <div v-if="loading" class="loading_card_spinner">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3"
                    color="var(--primary-color)" />

            </div>
        </div>
        <!-- END LOADER -->
        <div v-else>

            <div style="margin-top: 4%; margin-bottom: 4%;">
                <router-link :to="{
                    name: 'home',
                    params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"> {{ $t('home') }} </router-link>
                <router-link :to="{
                    name: 'home',
                    params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"> {{ DBitems.product.category }}</router-link>
                <a> {{ DBitems.product.name }} </a>

            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-6 " id="col_mobile">
                            <div>
                                <ol>


                                    <li v-for="(item, index) in this.DBitems.images.images"
                                        @click="change_image(index, item.src)" :id="'image' + index"
                                        class="image_items">
                                        <img :src="item.src" class="img_mini" />

                                    </li>
                                </ol>
                            </div>

                        </div>




                        <div class="col-lg-9 col-md-9 col-12 ">

                            <VueSlickCarousel ref="carousel" v-bind="settings"
                                class="slideshow-container product_images" dir="ltr">

                                <div v-for="(item, index) in this.DBitems.images.images"
                                    @click="change_image(index, item.src)" class="mySlides product_images">

                                    <img :src="item.src" class="item_images_product">

                                </div>

                            </VueSlickCarousel>
                             <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"
                    aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
            </div>
            <VueSlickCarousel v-bind="settings" class="carousel-inner" dir="ltr">

                <div v-for="(item, idx) in sliders" :key="idx" class="carousel-item banners">
                    <img :src="item.image" class="banners w-100" alt="Slide 1" style="display:flex">
                </div>


            </VueSlickCarousel>

          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
        </div>

                        </div>

                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-12" id="col_details">
                    <div class="d-flex justify-content-between">
                        <h2 style="margin-top: -8px;">
                            {{ DBitems.product.category }}</h2>
                        <button class="fav_product" v-if="this.$localStorage.get(this.$store.storeName) != null">


                            <i v-if="fav" @click="changeFav" class="fa fa-heart-o icon_grid2 is_fav_product "></i>
                            <i v-else @click="changeFav" class="fa fa-heart-o icon_grid2 "></i>
                        </button>
                    </div>
                    <p>{{ DBitems.product.name }}</p>

                    <!-- jellewry -->
                     <div v-if="jellwery[0]">

                        <p> {{ $t(jellwery[0].type) }}({{jellwery[0].count_gram}}/{{ jellwery[0].purity }} k)</p>

                        <table class="table table-bordered mt-3" v-if="jellwery && jellwery.length">
      <thead>
        <tr>
          <th>{{ $t('purity') }}</th>
          <th>{{ $t('weight') }}</th>
          <th>{{ $t('price') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in jellwery" :key="index">
          <!-- <td>{{ item.type }}</td> -->
          <!-- <td v-if="item.type=='gold'">{{ ($store.state.gold.qar_ask*(item.purity/24)).toFixed(2)}}</td>
           <td v-else>{{ $store.state.silver.qar_ask*(item.purity/24).toFixed(2)}}</td> -->
          <td>{{ item.purity }}</td>
          <!-- <td>{{ item.gold_manufacturing }}</td> -->
          <td>{{ item.count_gram }} {{ $t('gram') }}</td>
          <td>{{(calculateItemPrice(item)) }}</td>
        </tr>
      </tbody>

    </table>

                        </div>
                     <!-- end jellewry -->
                    <div style=" font-size: 15px;">
                        <a v-for="n in DBitems.rate" :key="n" href="#">
                            <span class="fa fa-star" style="color: #FCDC6E;"></span>
                        </a>
                        <a v-for="n in 5 - DBitems.rate" :key="n" href="#">
                            <span class="fa fa-star-o" style="color: #FCDC6E;"></span>
                        </a>



                        <span>({{ DBitems.count_rate }} {{ $t('rivew') }})</span>
                        <p style="font-size: 30px; font-weight: normal;">
                        <div class="price_one_product" v-if="jellwery[0]">
                            <span class="text-slate-400 font-semibold me-1">
                              {{ (calculateJewelryPrice()).toFixed(2) * counterVal}} {{ $store.state.UnitPrice }}
                            </span>
                        </div>
                        <div class="price_one_product" v-else-if="selectOption && this.DBitems.product.range_price">
                            <span class="text-slate-400 font-semibold me-1">
                                {{ this.DBitems.product.range_price.min_price * $store.state.rate }}{{
                                    $store.state.UnitPrice }} _
                                {{ this.DBitems.product.range_price.max_price * $store.state.rate }}{{
                                    $store.state.UnitPrice }}
                            </span>
                        </div>

                        <div class="price_one_product" v-else-if="selectOption">
                            <span class="text-slate-400 font-semibold me-1">
                                {{ $t('selectOption') }}
                            </span>
                        </div>
                        <!-- end if offer -->
                        <!-- if not offer -->
                        <div class="price_one_product" v-else-if="offer_price == 0">
                            <span class="text-slate-400 font-semibold me-1 product_price">
                                {{ (this.price * this.$store.state.rate).toFixed($store.state.digit_price) }} {{
                                    $store.state.UnitPrice }}
                            </span>
                        </div>
                        <!-- end if not offer -->


                        <!-- if not offer not new price -->
                        <div class="price_one_product" v-else>
                            <span class="text-slate-400 font-semibold me-1 product_price">
                                {{ (this.offer_price * this.$store.state.rate).toFixed($store.state.digit_price) }} {{
                                    this.$store.state.UnitPrice }}
                                <del class="text-red-600">
                                    {{ (this.price * this.$store.state.rate).toFixed($store.state.digit_price) }} {{
                                        this.$store.state.UnitPrice }}</del>
                            </span>
                            <div class="on_sale">
                                <span v-if="this.DBitems.product.is_offer == true">
                                    {{ $t('discount') }}:
                                    {{ DBitems.product.discount }}% </span>
                                <div class="orderInfo d-flex flex-row justify-content-between mt-1"
                                    v-if="this.DBitems.product.is_offer == true">
                                    <h4 style="color: var(--primary-color)">{{ $t("offerEnd") }} :</h4>
                                    <h5 style="color: var(--primary-color)">{{ this.DBitems.product.offer_end }}</h5>
                                </div>

                            </div>
                        </div>
                        <!-- end if not offer not new price --></p>


                        <div class="container my-4" v-if="DBitems.options.options.length != 0">
                            <!-- <h6 class="text-center mb-4"> {{ $t('select_option') }}</6> -->

                            <!-- قسم الحجم -->
                            <div v-for="(item, index) in DBitems.options.options" :key="index">
                                <h4 class="mb-3">{{ item.name }}</h4>
                                <div class="row g-3">
                                    <div v-for="(item1, index) in item.option_values.select_values"
                                        class="col-3 col-md-3">
                                        <label class="card  card_option_product"
                                            :title="$t('select option') + ' ' + item1.name"
                                            :id="'select_value' + item1.id" :for="item1.id + 'select' + index">
                                            <input type="radio" name="size" value="premier" class="form-check-input"
                                                :id="item1.id + 'select' + index" :name="'select' + item.id"
                                                :value="item1.id" :title="$t('SelectOne')"
                                                @change="upadateprice($event, item.id, item1.id)">
                                            <img :src="images[0].src" :alt="DBitems.product.name" class="img-fluid">
                                            <p class="text-center mt-2 option_product_title">{{ item1.name }}</p>
                                        </label>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div v-if="quanity != 0" class="orderInfo d-flex flex-row justify-content-between"
                            style="margin-bottom: 15px">
                            <h5>{{ $t("quantity") }} :</h5>

                            <div v-if="(quanity == 0 || max_quanity == 0) && !selectOption">{{ $t("NoQuantity") }}</div>
                            <div v-else-if="selectOption">{{ $t("selectOption") }}</div>
                            <div v-else class="d-flex flex-row justify-content-start align-items-center text-center"
                                style="
                  background-color: #fff;
                  box-shadow: 0px 0px 8px rgba(127, 137, 161, 0.25);
                  border-radius: 10px;
                ">
                                <button style="
                    background-color: transparent;
                    border: 0;
                    height: 20px;
                    min-width: 40px;
                  " @click="incrementClick()">
                                    <h4 style="font-size: 20px; line-height: 20px">+</h4>
                                </button>
                                <div>
                                    <h4 style="
                      background-color: transparent;
                      margin: 10px;
                      height: 20px;
                      min-width: 30px;
                      line-height: 20px;
                    " id="counter-label">{{ counterVal }}</h4>
                                </div>
                                <button style="
                    background-color: transparent;
                    border: 0;
                    height: 20px;
                    min-width: 40px;
                  " @click="decrementClick()">
                                    <h4 style="font-size: 20px; line-height: 20px">-</h4>
                                </button>
                            </div>
                        </div>


                    </div>
                    <br>
                    

                    <div class="product_mobile">
                        <button class="btn float_add  btn-shopping" id="#addToCart" v-if="quanity != 0"
                            @click="addToCart">
                            <i class="fa fa-shopping-cart icon_cart" id="icon_cart"></i>
                            <i id="icon_loading" style="display:none" class="fa fa-spinner fa-spin icon_loading" aria-hidden="true"></i>

                            {{ $t('ADD TO CART') }}</button>

                        <button class="btn float_add  btn-shopping" v-else disabled>

                            <i class="fa fa-shopping-cart icon_cart" id="icon_cart"></i>

                            {{ $t('ADD TO CART') }}</button>

                        <a class="btn float_add contact_cart_product  btn-shopping"
                            :href="'https://api.whatsapp.com/send/?phone=' + this.$store.state.phone + '&text=' + this.DBitems.product.msg + '&type=phone_number&app_absent=0'"><i
                                class="fa fa-whatsapp "></i> {{ $t('contactUs') }}</a>

                    </div>
                    <br>
                    <br>
                    <div class="product_description" v-html="DBitems.product.description">

                    </div>
                </div>
            </div>



            <div v-if="validateMessage != ''" class="validate_message">
                <div style="display: flex; align-items: center;">
                    <img v-if="this.DBitems.images" :src="this.DBitems.images.images[0].src" alt="Product"
                        style="width: 50px; height: 50px; border-radius: 8px; object-fit: cover; margin-right: 10px;">
                    <div style="text-align: left;">
                        <p style="margin: 0;font-weight:400">{{ $t('Qty') }}: {{ counterVal }}</p>
                        <p style="margin: 10px;font-weight:400">{{ validateMessage }}</p>

                    </div>
                </div>
            </div>

            <div v-if=" loginMessage!=''" style="
  position: fixed;
  z-index: 100;
  width: 320px;
  top: 20%;
  left: 50px;
  border-radius: 8px;
  background-color: white;
  border: 2px solid var(--primary-color);
  text-align: center;
  padding: 10px;
  color: black;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
">
                <p style="margin-top: 10px;">{{ loginMessage }}</p>
            </div>

        </div>
    </div>
</template>


<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import product from "../components/one_product_list.vue";
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";

export default {
    components: { VueSlickCarousel, product, HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner },

    data: function () {
        return {
            loading_price: false,
            counterVal: 1,
            loginVodal: false,
            loginMassage: "",
            old_qnt: 0,
            currentId: null,
            width: 600,
            height: 350,

            DBitems: null,
            loading: false,
            loading_checkout: false,
            loginMessage: '',
            options: [],
            selectedOptionArray: [],
            price: 0,
            quanity: 0,
            max_quanity: 0,
            min_quanity: 0,
            Firstquanity: 0,
            finalOptions: 0,
            checked: [],
            validateMessage: "",
            selectOption: false,
            images: null,
            count_images: null,
            fav: false,
            offer_price: 0,
            //is_offer: false,
            //discount: null,
            note: "",
            addeval: false,
            jellwery:[],

        };
    },
    created() {

        this.$store.state.topbar = 'topbar_light';
        this.$store.state.navbar = 'navbar_dark';

        this.loading = true;
        this.axios
            .get(
                this.$store.state.base_api_url +
                this.$store.storeName +
                "/product/theme5/" +
                this.$route.params.id,
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization:
                            "Bearer " + this.$localStorage.get(this.$store.storeName)
                    }
                }
            )
            .then(response => {
                this.checked = [];
                this.DBitems = response.data.data;
                if (this.DBitems.product.seo_title)
                    document.title = this.DBitems.product.seo_title;
                else
                    document.title = this.DBitems.product.name;
                if (this.DBitems.product.seo_description)
                    document.getElementById("description_meta").content = this.DBitems.product.seo_description;
                if (this.DBitems.product.seo_keyword)
                    document.getElementById("keywords_meta").content = this.DBitems.product.seo_keyword;
                this.fav = this.DBitems.product.is_favorit;
                this.images = response.data.data.images.images;
                // this.old_images=response.data.data.images.images;
                this.count_images = response.data.data.images.images.length
                var option1 = this.DBitems.options.options;
                var option2 = this.DBitems.options_check.options;
                for (var i = 0; i < option1.length; i++) {
                    //if option  not empty
                    if (option1[i].option_values.select_values != null) {
                        // if select
                        var element = {};
                        element.value_id = null;//option1[i].option_values.select_values[0].id;
                        element.option_id = option1[i].id;
                        this.options.push(element);
                        ///console.log(this.options.length +"iam theeeeeeeeeeeeeeer")
                    }
                }

                for (var i = 0; i < option2.length; i++) {
                    // if checkbox
                    var checked = {};
                    checked.id = option2[i].id;
                    checked.value = false;
                    this.checked.push(checked);
                    //console.log(this.checked)
                }

                //console.log(this.options)
            })
            .then(() => {
                this.loading = false;
                if (this.options.length != 0) {
                    this.selectOption = true;

                }
                else if (this.options.length == 0) {
                    // if we not found select options
                    //console.log("hiiiiiiiiii created" + this.DBitems.product.quanity);
                    this.price = this.DBitems.product.sale_price;
                    this.jellwery=this.DBitems.product.jewelry;
                    this.offer_price = this.DBitems.product.offer_price;
                    this.quanity = this.DBitems.product.quantity;
                    this.max_quanity = this.DBitems.product.quantity;
                    this.min_quanity = 1;
                    if (this.DBitems.product.min_qnt)
                        this.min_quanity = this.DBitems.product.min_qnt;
                    if (this.DBitems.product.max_qnt > 0)
                        this.max_quanity = this.DBitems.product.max_qnt;
                    this.Firstquanity = this.DBitems.product.quantity;

                    /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
                    var checked_true = [];
                    for (var i = 0; i < this.checked.length; i++) {
                        if (this.checked[i].value == true) {
                            checked_true.push(this.checked[i].id);
                        }
                    }
                    let S_name_full =
                        this.$store.storeName +
                        "/" +
                        this.$route.params.id +
                        this.finalOptions +
                        checked_true;

                    let S_name2 =
                        this.$store.storeName +
                        "/" +
                        this.$route.params.id +
                        this.finalOptions;
                    console.log("S_name " + S_name2);

                    let qun = this.quanity;
                    let min_qun = this.min_quanity;
                    let max_qun = this.max_quanity;
                    let AllCookies = this.$cookies.keys();
                    for (let i = 0; i < AllCookies.length; i++) {
                        if (AllCookies[i].includes(S_name2)) {
                            // if (AllCookies[i] == S_name_full) {
                            //  console.log("hii i am there ");
                            //} else {
                            this.old_qnt = this.$cookies.get(AllCookies[i]).quantity;
                            qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                            min_qun = min_qun - this.$cookies.get(AllCookies[i]).quantity;
                            if (min_qun < 0) {
                                min_qun = 1;
                            }
                            if (max_qun != -1)
                                max_qun = max_qun - this.$cookies.get(AllCookies[i]).quantity;
                            if (max_qun == -1) {
                                max_qun = -1;
                            }
                            else if (max_qun <= 0 && max_qun != -1) {
                                max_qun = 0;
                            }
                            console.log(
                                this.$cookies.get(AllCookies[i]).quantity + " quuuuunb" + qun
                            );
                            // }
                        }
                    }
                    this.quanity = qun;
                    this.min_quanity = min_qun;
                    this.max_quanity = max_qun;

                }
                if (this.min_quanity > 0) {
                    this.counterVal = this.min_quanity;
                    this.price *= this.counterVal;
                    this.offer_price *= this.counterVal;
                }
            });


        //counter value 


        //end counter value
    },
    methods: {
        goToSlide(index) {
            this.$refs.carousel.goTo(index);
        },
        showNext() {
            this.$refs.carousel.next()
        },
        change_image(index, src) {
            // for (var i = 0; i < this.images.length; i++) {
            //     document.getElementById('image' + i).style = "border:none !important";
            // }
            //  document.getElementById('image' + index).style = "border:1px solid var(--primary-color) !important";
            this.goToSlide(index);
        },
        incrementClick() {
            if (this.quanity > 0) {
                if (this.counterVal < this.quanity && this.counterVal < this.max_quanity) {
                    ++this.counterVal;
                    this.price = this.price / (this.counterVal - 1) + this.price;
                    if (this.offer_price > 0) {
                        this.offer_price =
                            this.offer_price / (this.counterVal - 1) + this.offer_price;
                        /*   this.offer_price =
                          this.price - (this.DBitems.product.discount / 100) * this.price;*/
                    }
                }
            } else {
                ++this.counterVal;
                this.price = this.price / (this.counterVal - 1) + this.price;
                if (this.offer_price > 0) {
                    this.offer_price =
                        this.offer_price / (this.counterVal - 1) + this.offer_price;
                    /* this.offer_price =
                      this.price - (this.DBitems.product.discount / 100) * this.price;*/
                }
            }
            //}
        },
        decrementClick() {
            if (this.counterVal > 1 && this.counterVal > this.min_quanity) {
                --this.counterVal;
                //this.price = this.price/2
                this.price = this.price - this.price / (this.counterVal + 1);
                if (this.offer_price > 0) {
                    this.offer_price =
                        this.offer_price - this.offer_price / (this.counterVal + 1);
                    /*    this.offer_price =
                      this.price - (this.DBitems.product.discount / 100) * this.price;*/
                }
            }
        },
        updatedata() {

            this.loading = true;
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/product/theme5/" +
                    this.$route.params.id,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data;
                    if (this.DBitems.product.seo_title)
                        document.title = this.DBitems.product.seo_title;
                    else
                        document.title = this.DBitems.product.name;
                    if (this.DBitems.product.seo_description)
                        document.getElementById("description_meta").content = this.DBitems.product.seo_description;
                    if (this.DBitems.product.seo_keyword)
                        document.getElementById("keywords_meta").content = this.DBitems.product.seo_keyword;
                    this.images = response.data.data.images.images;

                    this.fav = this.DBitems.product.is_favorit;
                })
                .then(() => (this.loading = false));

            //this.$refs.childref.update(this.categoryID)
            this.$store.state.langchange = false;
        },
        upadateprice(event, option_id, select_id) {
            this.loading_price = true;
            var element = document.getElementById('select_value' + select_id)

            console.log(element, '???????/')
            var collections = document.getElementsByClassName("option" + option_id);
            for (var i = 0; i < collections.length; i++) {
                if (collections[i])
                    collections[i].classList.remove('active')
            }
            if (element) {
                element.classList.add('active');
            }

            for (var i = 0; i < this.options.length; i++) {
                if (this.options[i].option_id == option_id) {
                    this.options[i].value_id = event.target.value;
                    if (this.selectedOptionArray.length < this.options.length) {
                        //if (!this.selectedOptionArray.includes(this.options[i].option_id)) {
                        this.selectedOptionArray.push(this.options[i].option_id);
                        //}
                    }
                }
            }
            //console.log(this.options.length  +" hii " +this.selectedOptionArray.length)
            if (this.options.length == this.selectedOptionArray.length) {
                this.selectOption = false;

                var options = this.options;
                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/product_price/" +
                        this.$route.params.id,
                        {
                            options
                        },
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale
                            }
                        }
                    )
                    .then(response => {
                        this.price = response.data.data.price;
                        this.offer_price = response.data.data.new_price;
                        this.quanity = response.data.data.quanity;
                        this.max_quanity = response.data.data.quanity;
                        this.min_quanity = 1;
                        if (response.data.data.min_qnt > 1)
                            this.min_quanity = response.data.data.min_qnt;
                        if (response.data.data.max_qnt > 0)
                            this.max_quanity = response.data.data.max_qnt;
                        this.Firstquanity = response.data.data.quanity;
                        this.finalOptions = response.data.data.final_option;
                        for (var i = 0; i < this.checked.length; i++) {
                            this.checked[i].value = false;
                        }
                        if (response.data.data.image) {
                            if (this.images.length > this.count_images)
                                this.images.shift();
                            this.images.unshift(

                                {
                                    id: '1',
                                    src: response.data.data.image,
                                    thumbnail: response.data.data.image
                                }

                            )
                        }

                        this.note = "";
                        var checked_true = [];
                        for (var i = 0; i < this.checked.length; i++) {
                            if (this.checked[i].value == true) {
                                checked_true.push(this.checked[i].id);
                            }
                        }
                        let S_name_full =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions +
                            checked_true;

                        let S_name2 =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions;
                        console.log("S_name " + S_name2);

                        let qun = this.quanity;
                        let min_qun = this.min_quanity;
                        let max_qun = this.max_quanity;

                        let AllCookies = this.$cookies.keys();
                        for (let i = 0; i < AllCookies.length; i++) {
                            if (AllCookies[i].includes(S_name2)) {
                                // if (AllCookies[i] == S_name_full) {
                                //  console.log("hii i am there ");
                                //} else {
                                this.old_qnt = this.$cookies.get(AllCookies[i]).quantity;
                                qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                                min_qun = min_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (min_qun < 0) {
                                    min_qun = 1;
                                }
                                if (max_qun != -1)
                                    max_qun = max_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (max_qun == -1) {
                                    max_qun = -1;
                                }
                                else if (max_qun <= 0 && max_qun != -1) {
                                    max_qun = 0;
                                }

                                console.log(
                                    this.$cookies.get(AllCookies[i]).quantity + " quuuuunx " + qun
                                );
                                // }
                            }
                        }
                        this.quanity = qun;
                        this.max_quanity = max_qun;
                        this.min_quanity = min_qun;


                        //test
                        if (this.min_quanity > 0) {
                            this.counterVal = this.min_quanity;
                            this.price *= this.counterVal;
                            this.offer_price *= this.counterVal;
                        }
                        else {
                            this.counterVal = 1;
                            this.price *= this.counterVal;
                            this.offer_price *= this.counterVal;
                        }

                        //
                        this.loading_price = false;
                    });
            }
        },
        updateall() {
            // this.loading = true;
            document.getElementById("#addToCart").disabled = false;

            this.selectOption = false;
            this.counterVal = 1;
            this.options = [];
            this.selectedOptionArray = [];
            this.price = 0;
            this.offer_price = 0;
            this.quanity = 0;
            this.min_quanity = 0;
            this.max_quanity = 0;
            this.Firstquanity = 0;
            this.finalOptions = 0;
            this.checked = [];
            //this.validateMessage = "";

            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/product/theme5/" +
                    this.$route.params.id,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.checked = [];
                    this.DBitems = response.data.data;
                    if (this.DBitems.product.seo_title)
                        document.title = this.DBitems.product.seo_title;
                    else
                        document.title = this.DBitems.product.name;
                    if (this.DBitems.product.seo_description)
                        document.getElementById("description_meta").content = this.DBitems.product.seo_description;
                    if (this.DBitems.product.seo_keyword)
                        document.getElementById("keywords_meta").content = this.DBitems.product.seo_keyword;
                    this.images = response.data.data.images.images;

                    this.fav = this.DBitems.product.is_favorit;
                    var option1 = this.DBitems.options.options;
                    for (var i = 0; i < option1.length; i++) {
                        //if option  not empty
                        if (option1[i].option_values.select_values != null) {
                            // if select
                            var element = {};
                            element.value_id = option1[i].option_values.select_values[0].id;
                            element.option_id = option1[i].id;
                            this.options.push(element);
                        } else {
                            // if checkbox
                            var checked = {};
                            checked.id = option1[i].id;
                            checked.value = false;
                            this.checked.push(checked);
                            //console.log(this.checked)
                        }
                    }
                    //console.log(this.options)
                })
                .then(() => {
                    this.loading = false;
                    if (this.options.length != 0) {
                        this.selectOption = true;

                    } else if (this.options.length == 0) {
                        // if we not found select options
                        console.log(
                            "hiiiiiiiiii updateall" + this.DBitems.product.sale_price
                        );
                        this.price = this.DBitems.product.sale_price;
                        this.offer_price = this.DBitems.product.offer_price;
                        this.min_quanity = 1;
                        if (this.DBitems.product.min_qnt)
                            this.min_quanity = this.DBitems.product.min_qnt;

                        this.max_quanity = this.DBitems.product.quantity;
                        if (this.DBitems.product.max_qnt > 0)
                            this.max_quanity = this.DBitems.product.max_qnt;

                        this.quanity = this.DBitems.product.quantity;
                        this.Firstquanity = this.DBitems.product.quantity;

                        /////////////nottttttttttttttttttteeeeeeeeeeeeeeeeeeee////////////
                        var checked_true = [];
                        for (var i = 0; i < this.checked.length; i++) {
                            if (this.checked[i].value == true) {
                                checked_true.push(this.checked[i].id);
                            }
                        }
                        let S_name_full =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions +
                            checked_true;

                        let S_name2 =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions;
                        console.log("S_name " + S_name2);

                        let qun = this.quanity;
                        let min_qun = this.min_quanity;
                        let max_qun = this.max_quanity;

                        let AllCookies = this.$cookies.keys();
                        for (let i = 0; i < AllCookies.length; i++) {
                            if (AllCookies[i].includes(S_name2)) {

                                console.log(
                                    " qnt " + qun
                                    + '<br> qnt_cookies ' + this.$cookies.get(AllCookies[i]).quantity
                                    + "<br> max_qnt " + max_qun
                                    + "<br> max_qnt cookies " + max_qun
                                );

                                this.old_qnt = this.$cookies.get(AllCookies[i]).quantity;
                                qun = qun - this.$cookies.get(AllCookies[i]).quantity;
                                min_qun = min_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (min_qun < 0) {
                                    min_qun = 1;
                                }
                                if (max_qun != -1)
                                    max_qun = max_qun - this.$cookies.get(AllCookies[i]).quantity;
                                if (max_qun == -1) {
                                    max_qun = -1;
                                }
                                else if (max_qun <= 0 && max_qun != -1) {
                                    max_qun = 0;
                                }
                                //this.$cookies.get(AllCookies[i]).quantity;
                                console.log(
                                    this.$cookies.get(AllCookies[i]).quantity + " quuuuuny  " + qun
                                    + "max_qnt " + max_qun
                                );
                                // }
                            }

                        }
                        this.quanity = qun;
                        this.min_quanity = min_qun;
                        this.max_quanity = max_qun;

                        if (this.min_quanity > 0) {
                            this.counterVal = this.min_quanity;
                            this.price *= this.counterVal;
                            this.offer_price *= this.counterVal;
                        }
                    }
                });
            var collections = document.getElementsByClassName("select_value_product");
            //option_value_radio
            for (var i = 0; i < collections.length; i++) {
                console.log("iii " + i)
                if (collections[i])
                    collections[i].classList.remove('active')
            }
            var collections2 = document.getElementsByClassName("option_value_radio");
            //option_value_radio
            for (var i = 0; i < collections2.length; i++) {
                console.log("iii2 " + i)
                if (collections2[i])
                    collections2[i].checked = false;
            }
        },
        addToCart() {

            this.loading_checkout = true;
            document.getElementById("icon_cart").style.display = "none";
            document.getElementById("icon_loading").style.display = "inline-block";
            document.getElementById("#addToCart").disabled = true;


            var checked_true = [];
            for (var i = 0; i < this.checked.length; i++) {
                if (this.checked[i].value == true) {
                    checked_true.push(this.checked[i].id);
                }
            }
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/check_cart_item",
                    {
                        product_id: this.$route.params.id,
                        total_price: this.price,
                        offer_price: this.offer_price,
                        quantity: Number(this.counterVal),
                        old_qnt: this.old_qnt,
                        final_option: this.finalOptions,
                        option_check: checked_true,
                        product_metal_id:this.jellwery[0]?this.jellwery[0].id:null,

                        
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale
                        }
                    }
                )
                .then(response => {
                    let product = null;
                    this.loading_checkout = false;
                    if (response.data.code == "1") {
                         this.validateMessage = this.$t('Added Cart Successfully');
                        // let products = new Map;
                        let S_name1 =
                            this.$store.storeName +
                            "/" +
                            this.$route.params.id +
                            this.finalOptions +
                            checked_true;
                        if (this.$cookies.isKey(S_name1)) {
                            console.log("$$$$$$$$$$", this.price, "$$$$$$$$$$$$$$$");
                            product = {
                                product_id: this.$route.params.id,
                                total_price:
                                    this.price + this.$cookies.get(S_name1).total_price,
                                offer_price:
                                    this.offer_price + this.$cookies.get(S_name1).offer_price,
                                quantity: Number(this.counterVal) + Number(this.$cookies.get(S_name1).quantity),
                                quantityAll: this.$cookies.get(S_name1).quantityAll,
                                max_quantity: this.$cookies.get(S_name1).max_quantity,
                                min_quantity: this.$cookies.get(S_name1).min_quantity,
                                final_option: this.finalOptions,
                                option_check: checked_true,
                                discount: this.DBitems.product.discount,
                                note: this.note + " " + this.$cookies.get(S_name1).note,
                                jellwery:this.jellwery[0],
                                product_metal_id:this.jellwery[0]?this.jellwery[0].id:null,
                            };
                        } else {
                            console.log("hlooooooooooo ::::::::; " + this.Firstquanity);
                            product = {
                                product_id: this.$route.params.id,
                                total_price: this.price,
                                offer_price: this.offer_price,
                                quantity: this.counterVal,
                                quantityAll: this.Firstquanity,
                                min_quantity: this.min_quanity,
                                max_quantity: this.max_quanity,
                                final_option: this.finalOptions,
                                option_check: checked_true,
                                discount: this.DBitems.product.discount,
                                note: this.note,
                                jellwery:this.jellwery[0],
                                product_metal_id:this.jellwery[0]?this.jellwery[0].id:null,
                            };
                        }
                        //check if item is exist on cart or not
                        //if (this.$cookies.isKey(this.$store.storeName+this.$route.params.id)) {
                        // this.$cookies.remove('storeName')
                        // products = this.$cookies.get(this.$store.storeName);
                        //}
                        //products.set(this.$route.params.id , product);
                        let S_name = this.$store.storeName + "/";

                        if (
                            !this.$cookies.isKey(
                                S_name +
                                product.product_id +
                                product.final_option +
                                product.option_check
                            )
                        ) {
                            this.$store.state.cartCounter = this.$store.state.cartCounter + 1;
                        }

                        this.$cookies.set(
                            S_name +
                            product.product_id +
                            product.final_option +
                            product.option_check,
                            product
                        );
                        console.log(this.$cookies.keys());
                    }
                    else{
                         this.validateMessage = response.data.message;

                    }
                    
                    this.updateall();
                    //document.getElementById("#addToCart").style.display = "block";
                    document.getElementById("icon_loading").style.display = "none";
                    document.getElementById("icon_cart").style.display = "inline-block";
                    setTimeout(() => {
                        // this.updateall();
                        this.validateMessage = "";
                    }, 3000);
                });

        },
        addEvalu() {
            if (
                this.$localStorage.get(this.$store.storeName) != null &&
                this.DBitems.product.is_rate == true
            ) {
                this.addeval = true;
            } else if (
                this.$localStorage.get(this.$store.storeName) != null &&
                this.DBitems.product.is_rate == false
            ) {
                if (this.$i18n.locale == "en") {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute(
                            "data-hover",
                            "You must purchase the product to add a review"
                        );
                } else {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute("data-hover", "يجب أن تشتري المنتج لإضافة تقييم");
                }
            } else {
                if (this.$i18n.locale == "en") {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute("data-hover", "login to add evaluation");
                } else {
                    document
                        .getElementsByClassName("hovertext")[0]
                        .setAttribute("data-hover", "سجل دخول لإضافة تقييم");
                }
            }
        },
        changeFav() {
            if (this.$localStorage.get(this.$store.storeName) != null) {
                this.axios
                    .get(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/favourite_product_change/" +
                        this.$route.params.id,
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale,
                                Authorization:
                                    "Bearer " + this.$localStorage.get(this.$store.storeName)
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.code == "1") {
                            this.fav = !this.fav;
                        }
                    });
            } else {
                if (this.$i18n.locale == "en") {
                    this.loginMassage = "please Login";
                    setTimeout(() => {
                        this.loginMassage = "";
                    }, 3000);
                } else {
                    this.loginMassage = "يجب تسجيل الدخول";
                    setTimeout(() => {
                        this.loginMassage = "";
                    }, 3000);
                }
            }
        },
        changeCheckbox(item, val) {
            if (val) {
                this.price = this.price + item.price * this.counterVal;
                if (this.offer_price != 0) {
                    this.offer_price = this.offer_price + item.price * this.counterVal;
                }
            } else {
                /*(this.offer_price =
                    this.price - (this.DBitems.product.discount / 100) * this.price))*/
                this.price = this.price - item.price * this.counterVal;
                if (this.offer_price != 0) {
                    this.offer_price = this.offer_price - item.price * this.counterVal;
                }
                /*(this.offer_price =
                    this.price - (this.DBitems.product.discount / 100) * this.price));*/
            }
        },
        show_section(id) {

            document.getElementById('description').style = "display:none";
            document.getElementById('addinfo').style = "display:none";
            document.getElementById('review').style = "display:none";

            document.getElementById('description-tab').style = "color:black;background-color:transparent";
            document.getElementById('addinfo-tab').style = "color:black;background-color:transparent";
            document.getElementById('review-tab').style = "color:black;background-color:transparent";

            document.getElementById(id).style = "display:block !important";
            document.getElementById(id + '-tab').style = "color:white;background-color: var(--primary-color);";

        },
         calculateJewelryPrice() {
    if (!this.jellwery || !Array.isArray(this.jellwery)) return 0;

    let totalPrice = 0;

    this.jellwery.forEach(item => {
      const manufacturingCost = Number(item.gold_manufacturing || 0); // المصنعية
      const gramCount = Number(item.count_gram || 1); // عدد الغرام
         let purityFactor =  item.purity /24;
      // حسب النوع (gold / silver)
      let typeMultiplier = 1;
      if (item.type === "gold") {
        typeMultiplier =  (this.$store.state.gold.qar_ask)*purityFactor; // يمكن تعديل إذا أردت زيادة سعر الذهب عن الفضّة
      } else if (item.type === "silver") {
        typeMultiplier = (this.$store.state.silver.qar_ask)*purityFactor; // يمكن تعديل إذا أردت سعر مختلف للفضة
      }

      totalPrice += (gramCount * (typeMultiplier + manufacturingCost));
    });

    return totalPrice;
  },
    calculateItemPrice(item) {
      let basePrice = item.type === "gold" ? this.$store.state.gold.qar_ask:
      this.$store.state.silver.qar_ask; // السعر على أساس عيار 24
      let purityFactor =  item.purity / 24;
      let manufacturing = Number(item.gold_manufacturing || 0);
      let countGram = Number(item.count_gram || 1);

      return (((basePrice * purityFactor) + manufacturing) * countGram).toFixed(2);
    },
    },
    watch: {
        "$route.params": {
            handler(newValue) {
                this.Dbitems = null;
                this.updateall();
            },
            immediate: true
        }
    }
};
</script>
<style></style>